// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__21wXn","brand":"Header_brand__1Eas8","headerText":"Header_headerText__1CHvJ","headerSeparator":"Header_headerSeparator__1TAwp"};